import React from 'react';
import { Redirect } from 'react-router-dom';

// Bailey's conversations now live beside Bailey's settings, in one place
// (Settings > AI receptionist). Old links, including ?c=<conversation>, land
// there.
export default function ReceptionInbox(props) {
    const search = (props.location && props.location.search) || '';
    return <Redirect to={`/settings/ai-assistant${search}`} />;
}
